<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p.u-mb-ts {{item.desc}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}


  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Graphic design ",
    "pageDesc":"We design Interactive websites, social media assets, logos, brand identities, advertising, illustration and more following a strategic approach.",
    "mantra":"Strategy driven |graphic design.",
    "sec1Items":{
      "1":{
        "title":"Unique designs",
        "desc":"Every pixel should be tailored by hand to create a harmonized and strong visuals."
      },
      "2":{
        "title":"Feeling over looks",
        "desc":"It's not about how the final design will look or the trends followed, it's about the feelings the design evokes."
      },
      "3":{
        "title":"Strategic direction",
        "desc":"A design that is not supported with strategy can’t thrive in the digital era or engage with the targeted audience."
      }
    },
    "sec2":"We apply our beliefs across all our services.",
    "sec2Items":{
      "1":{
        "title":"Branding",
        "desc":"We create brands that are driven by strategy to formulate unique experiences and design functional identities.",
        "url":"/services/branding"
      },
      "2":{
        "title":"Interaction",
        "desc":"We do strategic user experiences, design systems and user interfaces to create memorable interactions.",
        "url":"/services/interaction"
      },
      "3":{
        "title":"Advertising",
        "desc":"Designing TV commercials, outdoor, and online ads that helps you deliver your messages easily.",
        "url":"/services/advertising"
      },
      "4":{
        "title":"Editorial design",
        "desc":"Books, magazines and posters. Whatever your end design needs, we help you make it using type design.",
        "url":"/services/editorial-design"
      }
    },
    "cta":"Create viral <br> campaigns now."
  },
  "ar": {
    "pageTitle":"تصميم الجرافيك",
    "pageDesc":"نصمم مواقع الويب التفاعلية وأصول وسائل التواصل الإجتماعي والشعارات وهوية العلامات التجارية والإعلانات والإليستريشن.",
    "mantra":"تصميم الجرافيك القائم |على الاستراتيجية.",
    "sec1Items":{
      "1":{
        "title":"تصميمات فريدة.",
        "desc":"نعمل على تصميم كل بكسل من أجل إنشاء تصميمات متجانسة وقوية لجذب جمهورك المستهدف ."
      },
      "2":{
        "title":"الانطباع يفوق المظهر",
        "desc":"الأمر لا يتعلق بكيفية ظهور التصميم النهائي أو الاتجاهات المتبعة، بل يتعلق بالمشاعر التي يثيرها التصميم في نفوس الجمهور المستهدف."
      },
      "3":{
        "title":"اتجاه استراتيجي",
        "desc":"لا يمكن للتصميم الذي يهمل الاستراتيجية أن يستمر طويلًا في العصر الرقمي أو حتى يتفاعل معه الجمهور المستهدف."
      }
    },
    "sec2":"نطبق ما نؤمن به في جميع خدماتنا.",
    "sec2Items":{
      "1":{
        "title":"العلامة التجارية",
        "desc":"نخلق العلامة التجارية التي تعتمد على الاستراتيجية من أجل صياغة تجارب فريدة وتصميم هويات وظيفية.",
        "url":"/services/branding"
      },
      "2":{
        "title":"التصميم التفاعلي",
        "desc":"ننشأ تجربة المستخدم القائمة على الاستراتيجية وأنظمة التصميم وواجهات المستخدم من أجل إنشاء تفاعلات لا تنسى.",
        "url":"/services/interaction"
      },
      "3":{
        "title":"الإعلانات",
        "desc":"نعمل على تصميم الإعلانات التليفزيونية والإعلانات الخارجية وإعلانات عبر الإنترنت تساعدك على توصيل رسائلك بسهولة.",
        "url":"/services/advertising"
      },
      "4":{
        "title":"التصميم التحريري",
        "desc":"نساعد على تصميم الكتب والمجلات والبوسترات. مهما كان ما يحتاج إليه تصميمك النهائي، فإننا نساعدك على إنشائه.",
        "url":"/services/editorial-design"
      }
    },
    "cta":"اجعل التصميم يتطابق <br> مع الاستراتيجية."
  }
}
</i18n>
